module.exports = __webpack_public_path__ + "static/img/img_6.a13d839.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_6.webp
// module id = vip2
// module chunks = 4